import { useCallback } from "react";
import { Select } from "@mantine/core";

import type { BillingReportAccountType } from "../../services/reports.service";

interface AccountTypeFilterProps {
  value: BillingReportAccountType;
  onChange: (value: string | null) => void;
}

const ACCOUNT_TYPE_OPTIONS = [
  { value: "practice", label: "Practices" },
  { value: "surgery_center", label: "Surgery Centers" },
  { value: "sending_lab", label: "Sending Labs" },
];

export function AccountTypeFilter({ value, onChange }: AccountTypeFilterProps) {
  const handleChange = useCallback(
    (nextValue: string | null) => onChange(nextValue),
    [onChange]
  );

  return (
    <Select
      label="Account Type"
      data={ACCOUNT_TYPE_OPTIONS}
      value={value}
      onChange={handleChange}
      allowDeselect={false}
      w={210}
    />
  );
}
